import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';

const ProjectPopup = ({ open, onClose, project }) => {
    if (!project) return null;

    const { title, detailedDescription, image, video, detailedHighlights } = project;

    return (
        <Modal open={open} onClose={onClose}>
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    backgroundColor: 'rgba(0, 0, 0, 0.9)',
                    color: 'white',
                    borderRadius: 2,
                    padding: 4,
                    width: '80%',
                    maxWidth: '600px',
                    maxHeight: '90vh',
                    overflowY: 'auto',
                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.5)',
                }}
            >
                {video ? (
                    <Box
                        component="video"
                        src={video}
                        controls
                        sx={{
                            width: '100%',
                            height: '80%',
                            objectFit: 'contain',
                            borderRadius: 2,
                            marginBottom: 2,
                        }}
                    />
                ) : (
                    <Box
                        component="img"
                        src={image}
                        alt={`${title} image`}
                        sx={{
                            width: '100%',
                            height: '80%',
                            objectFit: 'contain',
                            borderRadius: 2,
                            marginBottom: 2,
                        }}
                    />
                )}
                <Typography variant="h4" sx={{ fontWeight: 'bold', marginBottom: 2 }}>
                    {title}
                </Typography>
                <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    {detailedDescription}
                </Typography>

                {detailedHighlights && (
                    <Box>
                        <Typography variant="h6" sx={{ marginTop: 3, marginBottom: 1, fontWeight: 'bold' }}>
                            Highlights:
                        </Typography>
                        <Box component="ul" sx={{ paddingLeft: 4 }}>
                            {detailedHighlights.map((detail, index) => (
                                <Typography key={index} component="li" variant="body2" sx={{ marginBottom: 1 }}>
                                    {detail}
                                </Typography>
                            ))}
                        </Box>
                    </Box>
                )}

                <Button onClick={onClose} variant="contained" sx={{ marginTop: 3, backgroundColor: '#1E88E5' }}>
                    Close
                </Button>
            </Box>
        </Modal>
    );
};

export default ProjectPopup;